module.exports = __webpack_public_path__ + "img/andrew.cec24c4a.png";